// 埋点id
export const actionStats = {
    // 顶部tab埋点
    open: 'pc_newschrome_open', // 新版资讯浏览器打开
    menuclick: 'pc_newschrome_open.cd', // 点击菜单按钮
    gsrj: 'pc_newschrome_open.cd.gsrj',  // 点击菜单-股市日记
    sc: 'pc_newschrome_open.cd.sc', // 点击菜单-收藏
    zxh: 'pc_newschrome_open.zxh', // 点击最小化
    zdh: 'pc_newschrome_open.zdh', // 点击最大化
    close: 'pc_newschrome_open.close', // 点击关闭

    // 网页内容埋点
    zlb: 'pc_newschrome_zlb', // 点击左侧列表
    xw: 'pc_newschrome_ggxw_zlb', // 点击新闻左侧列表
    gg: 'pc_newschrome_gggg_zlb', // 点击公告左侧列表
    yb: 'pc_newschrome_ggyb_zlb', // 点击研报左侧列表
    plfs: 'pc_newschrome_fspl_content', // 点击评论发送按钮
    plcg: 'pc_newschrome_plcg_toast', // 评论成功toast
    pldz: 'pc_newschrome_pldz_content', // 评论点赞
    plhf: 'pc_newschrome_plhf_content', // 点击评论回复
    plhfcg: 'pc_newschrome_plhfcg_toast', // 评论回复成功toast
    zxdz: 'pc_newschrome_zxdz_content', // 资讯下方点赞按钮
    zxza: 'pc_newschrome_zxz_content', // 资讯下方砸按钮
    sys: 'pc_newschrome_wxsys_content', // 扫一扫
    fzlj: 'pc_newschrome_fzlj_content', // 复制链接
    xwxl: 'pc_newschrome.page.xw.xiala', // 阅读新闻资讯下拉滚轮
    xwover: 'pc_newschrome_ggxw_content_over', // 个股新闻阅完资讯
    ybxl: 'pc_newschrome.page.yb.xiala', // 阅读研报资讯下拉滚轮
    ybover: 'pc_newschrome_ggyb_content_over', // 个股研报阅完资讯
    ggxl: 'pc_newschrome.page.gg.xiala', // 阅读公告资讯下拉滚轮
    ggover: 'pc_newschrome.page.gg.over', // 个股公告阅完资讯
    pageover: 'pc_newschrome_zx_over', // 资讯阅完总埋点

    jb_click:'pc_newschrome_jb_content',
    jb_0:'pc_newschrome_jb_ggrw_content',
    jb_1:'pc_newschrome_jb_dsyy_content',
    jb_2:'pc_newschrome_jb_mgsz_content',
    jb_3:'pc_newschrome_jb_btkz_content',
    jb_4:'pc_newschrome_jb_nryw_content',
    jb_5:'pc_newschrome_jb_cbz_content',
    jb_qx:'pc_newschrome_jb_qx_content',
    jb_cg:'pc_newschrome_jbcg_toast',

}

